import React from 'react';
import OptionsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList';
import { connect } from 'react-redux';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { selectOptionclassification } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import OptionsList from '../../Components/OptionsList';
import { setCreatorMobileProductListOpen, setCreatorMobileModalContent } from '../../../../Reducers/CustomCreatorReducer/Actions';

const mapStateToProps = ({
  ui, configurator, api, customCreatorData,
}) => {
  const showDialog = !!ui.visibilityMap.incompatibility || !!ui.visibilityMap.optionDetails;
  const optionclassification = ui.visibilityMap.optionlist ? configurator.selectedoptionclassification : {};
  const getOptions = () => {
    const options = [...configurator.options];
    if (optionclassification?.identifier?.includes('mine')) {
      options.sort((o1, o2) => {
        if (o1.netPrice === o2.netPrice) {
          if (o1.title !== o2.title) return -1;
          return o1.identifier < o2.identifier ? -1 : 1;
        }
        return o1.netPrice - o2.netPrice;
      });
    }
    return options;
  };
  return {
    Component: OptionsList,
    isLoading: api.isFetching && !showDialog,
    optionclassification,
    options: getOptions(),
    show: !!ui.visibilityMap.optionlist,
    doDisplayMobile: /* isMobileDevice() && */ customCreatorData.creatorMobileProductsListOpen,
    currentModalContentOption: customCreatorData.creatorMobileModalContent,
    modalContentOptions: customCreatorData.creatorMobileModalContentOptions,
    optionHasChanged: customCreatorData.creatorChangedClassifications,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setModalContentOption: (value) => {
    dispatch(setCreatorMobileModalContent(value));
  },
  onClose: () => {
    dispatch(setVisible('optionlist', false));
    // dispatch(selectOptionclassification(null));
  },
  setDisplayCreatorMobilePicker: (value) => {
    dispatch(setCreatorMobileProductListOpen(!!value));
  },
});
export default containerConnect(mapStateToProps, mapDispatchToProps);
